import { useTheme } from "@emotion/react";
import { Container, Grid, Paper, useMediaQuery } from "@mui/material";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import LoginComponent from "shared-components/src/components/login/Loign.component";
import logo from "../assets/images/Acquaount-logo.png";
import { routerPaths } from "../router/routerPaths";

const LoginPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const onLoginHandler = () => {
    navigate(routerPaths.home);
  };

  return (
    <Fragment>
      <div
        style={{
          background: theme.palette.primary.main,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Container>
          <Grid container justifyContent="center">
            <Grid item xs={12} sm={10} md={5}>
              <Paper elevation={3} style={{ padding: "20px" }}>
                <LoginComponent logo={logo} onLoginHandler={onLoginHandler} />
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </div>
    </Fragment>
  );
};

export default LoginPage;
